
import EditorInstagramPostList from 'Editors/EditorInstagramPostList'
import EditorTipTap from 'Editors/EditorTipTap'
import EditorLink from 'Editors/EditorLink'

export default {
  components: {
    EditorInstagramPostList,
    EditorTipTap,
    EditorLink,
  },
  data() {
    return {
      inView: false,
      swiperOptions: {
        slidesPerGroup: 4,
        slidesPerView: 4,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          1024: {
            slidesPerGroup: 4,
            slidesPerView: 4,
            spaceBetween: 0,
          },
          768: {
            slidesPerGroup: 3,
            slidesPerView: 3,
            spaceBetween: 0,
          },
          0: {
            slidesPerGroup: 2,
            slidesPerView: 2,
            spaceBetween: 0,
          },
        },
      },
    }
  },
}
